import { User } from './types';
import { request } from './createRequest';

export const getCustomer = (): Promise<User> => {
  return request.get(`/v1/customers/me`).then((res) => res.data.data);
};

export const getCustomerById = (customerId: string | undefined): Promise<User> => {
  return request.get(`/v1/customers/${customerId}`).then((res) => res.data.data);
};
